<app-eurostar-loading-screen [animated]="false"></app-eurostar-loading-screen>
@if (
  {
    results: (searchParams.results | async) || [],
    messages: searchParams.messages | async
  };
  as data
) {
  <div>
    <h2 class="visuallyhidden" i18n="@@searchCriteria">Search Criteria</h2>
    <a href="#eurostart" (click)="skipToResultContent()" class="sr-only sr-only-focusable"
      >Skip to result content</a
    >
    <app-invoked-user></app-invoked-user>
  </div>
  <div class="eurostar_research_form background-container-background">
    <app-search-toggle [serviceType]="ServiceType.Eurostar">
      <app-validate-errors [messages]="data.messages"></app-validate-errors>
      <app-eurostar-search></app-eurostar-search>
      <div class="flex-row-container flex-row-container--right eurostar_research_row">
        <button
          i18n-title
          appButton="large-search"
          title="Start another search"
          (click)="reSearch()"
          i18n="@@eurostarSearch"
        >
          Search
        </button>
      </div>
    </app-search-toggle>
  </div>
  @if (destination) {
    <app-risk-alerts [countryCode]="destination"> </app-risk-alerts>
  }
  <!-- <app-validate-errors for="eurostar"></app-validate-errors> -->
  <!-- <app-eurostar-search-results></app-eurostar-search-results> -->
  @if (flightSearchParams.eurostarFromFlightSearchPerformed) {
    <app-carbon-comparison-eurostar> </app-carbon-comparison-eurostar>
  }
  <div class="flex-row-container switchrail_container">
    @if (searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount) {
      <button
        (click)="switchToHotel()"
        appButton="small"
        class="alternative-button"
        id="eurostarresults-button-switchtoHotel"
      >
        <i class="ico-bed" aria-hidden="true"></i>
        <span i18n="@@flightHotelsFrom">Hotels from:</span>&nbsp;
        {{
          searchService.searches[ServiceType.Hotel].cheapestPrice.amount
            | currency: searchService.searches[ServiceType.Hotel].cheapestPrice.currencyCode
        }}
      </button>
    }
  </div>
  <div
    appStickyBlock
    [attr.margin]="70"
    [attr.marginFix]="30"
    class="eurostar-class-header half-container flex-row-container"
  >
    @if (flightSearchParams.eurostarFromFlightSearchPerformed) {
      <button
        appButton="small"
        class="back-to-button"
        routerLink="/results/flights"
        i18n="@@backToFlights"
        id="eurostar-button-back-to-flights"
      >
        <i class="ico-flight" aria-hidden="true"></i>
        Back to flights
      </button>
    }
    <div class="half-block">
      <div class="flex-column-container">
        <span class="extras-label">Sort by:</span>
        <app-sorting-toggle
          id="eurostart"
          [sortingTypes]="searchParams.sortDropdownValuesLu"
          (sortingSelected)="onSortingSelected($event)"
        ></app-sorting-toggle>
      </div>
    </div>
    <label
      id="eurostar-open-fare-rules-modal"
      class="visuallyhidden"
      i18n="@@EurostarOpenFareRulesModal"
      >Open fare rules modal to see details</label
    >
    <div
      aria-labelledby="eurostar-open-fare-rules-modal"
      (click)="openFareRules()"
      role="button"
      class="half-block flex-row-container"
    >
      @if (showClasses?.standard) {
        <div
          (keydown.enter)="openFareRulesAndFocus()"
          tabindex="0"
          id="fareRulesStand"
          alt="For more information regarding the fare conditions select here"
          class="eurostar-class-header_item-class eurostar-class-header_item-class--standard"
        >
          <span i18n="@@eurostarStandard">Eurostar Standard</span>
          <section (mouseleave)="tt.close()" class="container">
            <i
              class="ico-info"
              ngbTooltip="For more information regarding the fare conditions select here"
              aria-label="For more information regarding the fare conditions select here"
              i18n-ngbTooltip
              i18n-aria-label
              triggers="manual"
              #tt="ngbTooltip"
              (mouseenter)="tt.open()"
              (focus)="tt.open()"
              (blur)="tt.close()"
              tabindex="0"
            >
              <span class="visuallyhidden"
                >For more information regarding the fare conditions select here</span
              ></i
            >
          </section>
        </div>
      }
      @if (showClasses?.standardPremier) {
        <div
          (keydown.enter)="openFareRulesAndFocus()"
          tabindex="0"
          id="fareRulesStandPrem"
          alt="For more information regarding the fare conditions select here"
          class="eurostar-class-header_item-class eurostar-class-header_item-class--standardPremier"
        >
          <span i18n="@@eurostarStandardPremier">Eurostar Plus</span>
          <section (mouseleave)="tt2.close()" class="container">
            <i
              class="ico-info"
              triggers="manual"
              #tt2="ngbTooltip"
              (mouseenter)="tt2.open()"
              (focus)="tt2.open()"
              (blur)="tt2.close()"
              tabindex="0"
              ngbTooltip="For more information regarding the fare conditions select here"
              i18n-ngbTooltip
              i18n-aria-label
              aria-label="For more information regarding the fare conditions select here"
              placement="bottom"
              ><span class="visuallyhidden"
                >For more information regarding the fare conditions select here</span
              ></i
            >
          </section>
        </div>
      }
      @if (showClasses?.businessPremier) {
        <div
          (keydown.enter)="openFareRulesAndFocus()"
          tabindex="0"
          id="fareRulesBus"
          alt="For more information regarding the fare conditions select here"
          class="eurostar-class-header_item-class eurostar-class-header_item-class--businessPremier"
        >
          <span i18n="@@eurostarBusinessPremier">Eurostar Premier</span>
          <section (mouseleave)="tt3.close()" class="container">
            <i
              class="ico-info"
              ngbTooltip="For more information regarding the fare conditions select here"
              i18n-ngbTooltip
              i18n-aria-label
              aria-label="For more information regarding the fare conditions select here"
              triggers="manual"
              #tt3="ngbTooltip"
              (mouseenter)="tt3.open()"
              (focus)="tt3.open()"
              (blur)="tt3.close()"
              tabindex="0"
            >
              <span class="visuallyhidden"
                >For more information regarding the fare conditions select here</span
              ></i
            >
          </section>
        </div>
      }
    </div>
  </div>
  <app-eurostar-list
    resType="outbound"
    [from]="search.departLocation"
    [to]="search.arriveLocation"
    [date]="search.outBoundDate"
    [results]="data.results[0]?.outbound"
    [showClasses]="showClasses"
  ></app-eurostar-list>
  <app-eurostar-list
    resType="inbound"
    [from]="search.arriveLocation"
    [to]="search.departLocation"
    [date]="search.inboundDate"
    [results]="data.results[0]?.inbound"
    [showClasses]="showClasses"
  ></app-eurostar-list>
  @if (!data.results[0]?.outbound.length) {
    <app-no-results></app-no-results>
  }
}
